export const PRICING_DETAILS_FILTERS = {
	binSet: 'bin_set',
	noBinSet: 'no_bin_set',
	reserveSet: 'reserve_set',
	noReserveSet: 'no_reserve_set',
	sellerCountered: 'seller_countered',
	noSellerCounter: 'no_seller_counter',
	noOffersReceived: 'no_offers_received',
	noBidAsEligible: 'no_bid_as_eligible',
	offersReceived: 'offers_received',
};

export const DEFAULT_SORTING_OPTION = {
	value: { order_by_spread: true, direction: 'asc' },
	text: 'Spread (smallest)',
};

export const RECOMMENDED_SORTING_OPTION = {
	value: { order_by_recommended_priority: true },
	text: 'Recommended priority',
};

export const getDefaultSortingOption = (isRecommendedPriorityEnabled) =>
	isRecommendedPriorityEnabled ? RECOMMENDED_SORTING_OPTION : DEFAULT_SORTING_OPTION;

export const isRecommendedSorting = (sorting) => sorting?.order_by_recommended_priority === true;

const DEFAULT_SORTING_OPTIONS = [
	DEFAULT_SORTING_OPTION,
	{ value: { order_by_spread: true, direction: 'desc' }, text: 'Spread (largest)' },
	{ value: { order_by_expires_at: true }, text: 'Expiring (soonest)' },
	{ value: { order_by_activity: true, direction: 'desc' }, text: 'Activity (most recent)' },
	{ value: { order_by_activity: true, direction: 'asc' }, text: 'Activity (oldest)' },
	{ value: { order_by_buyer_name: true, direction: 'asc' }, text: 'Buyer A-Z' },
	{ value: { order_by_buyer_name: true, direction: 'desc' }, text: 'Buyer Z-A' },
	{ value: { order_by_seller_name: true, direction: 'asc' }, text: 'Seller A-Z' },
	{ value: { order_by_seller_name: true, direction: 'desc' }, text: 'Seller Z-A' },
	{ value: { order_by_seller_close_rate: true, direction: 'desc' }, text: 'Seller close rate (highest)' },
	{ value: { order_by_seller_close_rate: true, direction: 'asc' }, text: 'Seller close rate (lowest)' },
];

export const getSortingOptions = (isRecommendedPriorityEnabled) =>
	isRecommendedPriorityEnabled ? [RECOMMENDED_SORTING_OPTION, ...DEFAULT_SORTING_OPTIONS] : DEFAULT_SORTING_OPTIONS;

export const SORTING_OPTIONS = DEFAULT_SORTING_OPTIONS;

export const initialState = {
	metadata: null,
	loading: false,
	success: undefined,
	data: null,
	scopeableEntities: {
		data: [],
		loading: false,
		success: undefined,
		metadata: null,
		formData: { name: null },
		selectedEntityName: null,
		selectedEntityType: null,
	},
	accounts: {
		data: [],
		loading: false,
		success: undefined,
		metadata: null,
		formData: { name: null },
		selectedAccounts: [],
	},
	dealerships: {
		data: [],
		loading: false,
		success: undefined,
		metadata: null,
		formData: { name: null },
		selectedDealerships: [],
	},
	users: {
		data: [],
		loading: false,
		success: undefined,
		metadata: null,
		formData: { name: null },
		selectedUsers: [],
	},
	closedMarketplaces: {
		data: [],
		loading: true,
		success: undefined,
	},
	discountApprovalRequest: {
		loading: false,
		success: undefined,
	},
	filters: {
		keywords: '',
		my_turn: null,
		deal_working_statuses: null,
		sale_type: null,
		deal_worker: undefined,
		territory: undefined,
		[PRICING_DETAILS_FILTERS.binSet]: false,
		[PRICING_DETAILS_FILTERS.noBinSet]: false,
		[PRICING_DETAILS_FILTERS.reserveSet]: false,
		[PRICING_DETAILS_FILTERS.noReserveSet]: false,
		[PRICING_DETAILS_FILTERS.sellerCountered]: false,
		[PRICING_DETAILS_FILTERS.noSellerCounter]: false,
		[PRICING_DETAILS_FILTERS.noOffersReceived]: false,
		[PRICING_DETAILS_FILTERS.noBidAsEligible]: false,
		deal_working_side: null,
		expires_today: null,
		account_id: null,
		dealership_id: null,
		user_id: null,
	},
	sorting: null,
	previousFilters: {},
	errors: {
		expandAllErrorMessage: '',
		dataErrorMessage: '',
		scopeableEntitiesErrorMessage: '',
		accountsErrorMessage: '',
		dealershipsErrorMessage: '',
		usersErrorMessage: '',
		discountApprovalRequestErrorMessage: '',
	},
	newIds: {
		data: [],
		success: undefined,
	},
};

export const FILTERS_STORAGE_KEY = 'dealDriverURLStorage';

export const SORTING_KEYS = ['order_by_', 'direction'];
